import {
  TextButton,
  TextButtonColor,
} from 'components/uikit/buttons/TextButton';
import { Control, Controller } from 'react-hook-form';
import { useEffect, useRef, useState } from 'react';
import CloseIcon from 'assets/icons/close-button.svg?react';
import { useScopedTranslation } from 'application/localization/useScopedTranslation';
import EmojiPicker, { Emoji } from 'emoji-picker-react';
import { useTriggerOnClickOutsideElement } from 'helpers/useTriggerOnClickOutsideElement';

import styles from './IconPicker.module.scss';
import { AdvancedFormReturnType } from 'helpers/form/useAdvancedForm';

type EmojiPickerProps = {
  form: AdvancedFormReturnType<any, object>;
  controlName: string;
  name: string;
  defaultIconCode: string;
};

export const IconPicker: React.FC<EmojiPickerProps> = (props) => {
  const defaultIcon = '1f981';
  const i18n = useScopedTranslation('Component.IconPicker');
  const [pickerVisibility, setPickerVisibility] = useState<boolean>(false);
  const [selectedIcon, setSelectedIcon] = useState<string>(
    props.defaultIconCode,
  );

  useEffect(() => {
    setSelectedIcon(props.defaultIconCode);
  }, [props.defaultIconCode]);

  useEffect(() => {
    if (selectedIcon === '') {
      props.form.setValue('iconCode', defaultIcon);
    }
  }, [selectedIcon]);

  if (!selectedIcon) {
    return (
      <div>
        <TextButton
          className={styles.button}
          title={i18n.t('choose_icon')}
          color={TextButtonColor.Primary}
          onClick={() => {
            setPickerVisibility(!pickerVisibility);
          }}
        />
        <OutsideClicker onClickOutside={() => setPickerVisibility(false)}>
          <div
            className={pickerVisibility ? styles.picker : styles.picker_hide}
          >
            <Controller
              name={props.name}
              control={props.form.control}
              defaultValue={defaultIcon}
              render={({ field: { onChange } }) => (
                <EmojiPicker
                  onEmojiClick={(emoji, event) => {
                    onChange(emoji.unified);
                    setPickerVisibility(false);
                    setSelectedIcon(emoji.unified);
                  }}
                />
              )}
            />
          </div>
        </OutsideClicker>
      </div>
    );
  } else {
    return (
      <div className={styles.icon}>
        <Emoji unified={selectedIcon} size={55} />
        <CloseIcon
          className={styles.closeButton}
          onClick={() => {
            setSelectedIcon('');
          }}
        />
      </div>
    );
  }
};

function OutsideClicker(props: any) {
  const wrapperRef = useRef(null!);
  useTriggerOnClickOutsideElement(wrapperRef, props.onClickOutside, true);

  return <div ref={wrapperRef}>{props.children}</div>;
}
